<template>
    <modal v-model="show" :submit="add" :cancel="cancel" :disabled="!isSelected(item)" :title="title" submit-text="Save">

        <template slot="body" v-if="type === 'subtasks'">
            <fg-input required
                      name="title"
                      :label="$t('Title')"
                      autocomplete="off"
                      v-model="item.title">
            </fg-input>
            <fg-input :label="$t('Description')">
                <el-input type="textarea"
                          :autosize="{ minRows: 3, maxRows: 4}"
                          v-model="item.description"/>
            </fg-input>
        </template>

    </modal>
</template>

<script>
    import { Input } from 'element-ui'
    import Modal from '../../Dashboard/Components/BasicModal'
    import isEmpty from 'lodash/isEmpty'
    import findIndex from 'lodash/findIndex'

    export default {
        name: 'TaskModal',

        components: {
            [Input.name]: Input,
            Modal
        },
        props: {
            value: {
                type: Object
            },
            show: {
                type: Boolean
            },
            type: {
                type: String
            },
            cancel: {
                type: Function
            },
            index: {
                type: Number
            }
        },
        data () {
            return {
                item: {},
                title: ''
            }
        },
        methods: {
            subtasksFilter: function (item) {
                return findIndex(this.value.subtasks, v => v.user._id === item._id) === -1
            },
            isSelected: function (item) {
                return !isEmpty(item)
            },
            add: function () {
                const {item, type} = this
                const newValue = this.value
                if (type === 'subtasks') {
                    if (this.index != null) {
                        newValue.subtasks[this.index].title = item.title
                        newValue.subtasks[this.index].description = item.description
                    } else {
                        newValue.subtasks.push(item)
                    }
                }
                this.$emit('input', this.newValue)
                this.cancel()
            }
        },
        watch: {
            type (val) {
                switch (val) {
                    case 'subtasks':
                        this.title = this.index == null ? this.$t('Add Subtask') : this.$t('Edit Subtask')
                        this.item = {
                            title: this.value.subtasks[this.index].title,
                            description: this.value.subtasks[this.index].description,
                        }
                        break
                    default:
                        this.title = ''
                        this.item = {}
                        break
                }
            }
        }
    }
</script>